
export function maskQuestionnaire(questionnaire, config) {
  let masked_sections = fromConfig(config)

  return questionnaire.filter(
    (section, index) => masked_sections[index]
  )
}

export function toConfig(show_sections_array) {
  return show_sections_array.reduce( (a, b) => a + Number(Boolean(b)), "" )
}

export function fromConfig(config) {
  let values = config.split("")
  return values.map( e => Boolean(Number(e)) )
}

export function exportAnswerObject(questionnaire) {
  let answers = {}
  questionnaire.forEach((el, i) => {
    answers['c_'+ (i+1)] = el.comments
    el.questions.forEach((q, j) => {
      answers['q_' + (i+1) + '_' + (j+1)] = q.a
    })
  })
  return answers
}

export function computeScores(questionnaire) {
  let conversion_map = {
    "y": 1,
    "p": 0.5,
    "a": 0.5,
    "n": 0
  }
  return questionnaire.map(s => s.questions
    .filter(q => q.o !== "") // consider only the multiple choice answers
    .map(q => conversion_map[q.a])
    .reduce( (a, b) => Number(a) + Number(b) )
  )
}

export function scoresToString(scores) {
  return scores.join(";")
}

export function stringToScores(string) {
  let strings = string.split(";")
  return strings.map(s => s === "" ? null : Number(s))
}

export function computeResultId(config, scores) {
  let masked_sections = fromConfig(config)

  for (let i = 0; i < masked_sections.length; i++) {
    if (masked_sections[i]) continue
    scores.splice(i, 0, null)
  }

  return scoresToString(scores)
}

export function attachScores(questionnaire, results) {
  let scores = stringToScores(results);
  let config = toConfig(scores.map(e => e))

  questionnaire.forEach((s, i) => s.score = scores[i])

  let masked_questionnaire = maskQuestionnaire(questionnaire, config)

  let totals = masked_questionnaire
    .map(section => section.questions)
    .map(
      section => section
        .filter(q => q.o !== "") // consider only the multiple choice answers
        .map(q => 1) // maximum 1 point per answer
        .reduce((a,b) => a+b)
    )

  masked_questionnaire.map((s, i) => s.tot = totals[i])
  masked_questionnaire.map(s => s.pct = Math.round((s.score / s.tot) * 100))

  return masked_questionnaire
}
